export default __webpack_public_path__ + "static/media/gem-icon-purple.1a2d4fd2.svg";